export default {
    txt_chinese: '중국어-Chinese',
    txt_english: '영어-English',
    txt_malay: '말레이시아어-Malay',
    txt_contactway: '연락 방식',
    //数据总览模块
    txt_Wear: '마모',
    txt_Pwear: '편마모',
    txt_NoData: '데이터 없음',
    txt_GoodState: '상태 양호',
    txt_LightWear: '경미한',
    txt_GraveWear: '심각한',
    txt_Border: '경계 상태',
    txt_replace: '즉시 교체',
    txt_sldw: '휠 얼라인먼트',
    txt_qt: '기타',
    //机会
    txt_ckbg: '보고서 보기',
    //设备
    txt_beiz: '비고',
    //检测记录
    txt_khsj: '고객 휴대폰',
    txt_cphm: '번호판 번호',
    txt_clxh: '차량 모델',
    txt_jcsj: '검사 시간',
    txt_msqk: '마모 상태',
    txt_zc: '정상',
    txt_qd: '확인',
    txt_sldwd: '휠 얼라인먼트',
    txt_zcd: '정상',
    txt_fwmd: '서비스 매장',
    txt_mddz: '매장 주소',
    txt_jcsb: '검사 장비',
    txt_ddmd: '방문 목적',
    txt_lic: '마일리지',
    txt_chex: '차종',
    txt_jcjyi: '검사 권장',
    txt_ysbs: '색상 인식',
    txt_ztms: '전체적 마모',
    txt_dqscjltx: '현재 제동 거리 알림',
    txt_hwmsjh: '균일한 트레드 마모',
    txt_zqlun: '좌측 전방 타이어',
    txt_zhlun: '좌측 후방 타이어',
    txt_yqlun: '우측 전방 타이어',
    txt_yhlun: '우측 후방 타이어',
    txt_pingjunzhi: '평균치',
    txt_guige: '사양',
    txt_gongli: 'Km',
    txt_ltwjc: '타이어 미검사',
    txt_pinpai: '브랜드',
    txt_ltws: '타이어 외관',
    txt_sewmts: '보고서를 확인하려면\nQR코드를 스캔하세요',
    txt_print: '인쇄 ',
    //店员管理
    //登录
    //登录新
    //门店
    //商户数据总览
    txt_jianyi: '제안',
    txt_jianyineirong: '타이어 편마모 발생, 추가 검사 권장.',
    txt_jianyineirongzc: '정상',
    txt_bgtixing: '알림:',
    txt_bgtuxubfnr: '현재 타이어 마모 상태에 따라,제동 거리가{0}%（추정치） 늘어날 수 있습니다',
    txt_waishang: '손상',
    txt_laohua: '노화',
    txt_gubao: '벌지',
    txt_xichemeirong: '세차 및 미용',
    txt_weixiubaoyang: '유지보수',
    txt_guenghuanluntai: '타이어 교체',
    txt_scsltjcy: '휴대용 타이어 검사기',
    txt_lf_outworn: '좌측 전방 타이어 바깥쪽이 안쪽보다 심하게 마모되었습니다.',
    txt_lf_innerworn: '좌측 전방 타이어 안쪽이 바깥쪽보다 심하게 마모되었습니다.',
    txt_lf_bothsideworn: '좌측 전방 타이어 양쪽이 중간보다 심하게 마모되었습니다.',
    txt_lf_centreworn: '좌측 전방 타이어 중간이 양쪽보다 심하게 마모되었습니다.',
    txt_lb_outworn: '좌측 후방 타이어 바깥쪽이 안쪽보다 심하게 마모되었습니다.',       
    txt_lb_innerworn: '좌측 후방 타이어 안쪽이 바깥쪽보다 심하게 마모되었습니다.',        
    txt_lb_bothsideworn: '좌측 후방 타이어 양쪽이 중간보다 심하게 마모되었습니다.',        
    txt_lb_centreworn: '좌측 후방 타이어 중간이 양쪽보다 심하게 마모되었습니다.',        
    txt_rb_outworn: '우측 후방 타이어 바깥쪽이 안쪽보다 심하게 마모되었습니다.',         
    txt_rb_innerworn: '우측 후방 타이어 안쪽이 바깥쪽보다 심하게 마모되었습니다.',        
    txt_rb_bothsideworn: '우측 후방 타이어 양쪽이 중간보다 심하게 마모되었습니다.',         
    txt_rb_centreworn: '우측 후방 타이어 중간이 양쪽보다 심하게 마모되었습니다.',        
    txt_rf_outworn: '우측 전방 타이어 바깥쪽이 안쪽보다 심하게 마모되었습니다.',         
    txt_rf_innerworn: '우측 전방 타이어 안쪽이 바깥쪽보다 심하게 마모되었습니다.',        
    txt_rf_bothsideworn: '우측 전방 타이어 양쪽이 중간보다 심하게 마모되었습니다.',       
    txt_rf_centreworn: '우측 전방 타이어 중간이 양쪽보다 심하게 마모되었습니다.',  
    txt_tire_need_replace: '즉시 교체해야 할 마모 타이어가 있습니다.',
    txt_alignment_chassis: '휠 얼라인먼트 또는 섀시 추가 검사 권장',
    txt_do_further_check: '추가 검사를 받으세요',
    txt_uneven_check:'타이어 마모 비정상, 동적 밸런스 및 휠 얼라인먼트,서스펜션 시스템을 검사하는 것이 좋습니다.',
    txt_tire_rotation: '타이어 로테이션 권장',           
    txt_wear_normal: '타이어 마모 정상',   
    'txt_wear_normal;': '타이어 마모 정상',     
    txt_tire: '타이어',
    txt_gelie: '크랙',
    txt_diaokuai: '청킹',
    txt_chaungci: '치핑',
    txt_cashang: '스크래치',
    txt_wear_overall: '전체적 마모',
    txt_pattern_wear: '비정상적 마모',
    txt_tire_age: '타이어 연령',
    txt_tire_appearance: '타이어 외관',
    txt_tire_age_5:'타이어를 5년 이상 사용하였으므로 타이어를 전면 검사하고, 필요한 경우 교체하는 것이 좋습니다.',
    txt_tire_age_8:'轮胎有效期已超过8年，建议更换轮胎',
    txt_tire_age_6:'轮胎有效期已超过6年，请定期进行检查',
    txt_tire_age_3:'타이어 유효기한이 3년을 초과하였므로 정기적으로 검사하세요.',
    txt_tire_age_ok: '타이어 연령 양호',
    txt_tire_trauma_check: '타이어 표면 손상, 추가 검사를 받는 것이 좋습니다.',
    txt_install_abnormal_check: '타이어 반대로 장착, 확인하고 처리하세요',
    txt_tire_appearance_ok: '타이어 외관 양호',
    txt_ltlcgstm: '현재 타이어 마모 상태에 따르면, 타이어의 남은 수명은{0}km(추정치)입니다',
    'txt_tire_need_replace;': '즉시 교체해야 할 마모 타이어가 있습니다.',
    'txt_uneven_check;': '타이어 마모 비정상, 동적 밸런스 및 휠 얼라인먼트,서스펜션 시스템을 검사하는 것이 좋습니다.  ',
    'txt_tire_age_ok': '타이어 연령 양호',
    'txt_wear_uniform;': '단일 타이어의 마모가 비교적 균일합니다',    
    txt_wear_uniform: '단일 타이어의 마모가 비교적 균일합니다',    
    'txt_tire_boundary;': '타이어 마모가 이미 경계 상태에 달했습니다.',     
    txt_tire_boundary: '타이어 마모가 이미 경계 상태에 달했습니다.', 
    txt_ltxhlcgs: '타이어 수명 추정',
    txt_ltazhuang: '타이어 장착:',
    txt_dqltlctx: '현재 타이어가 한계에 달했으니 즉시 타이어를 교체하세요.',
    txt_dottx: '타이어 사용 수명 추정',
    txt_danweikm: '(단위：km）',
    txt_dotjstx: '타이어의 남은 수명은 {0}일입니다.',
    txt_dotsjztx: '(DOT：타이어 제조일자)',
    'txt_tire_age_ok;': '타이어 연령 양호',
    //微信公众号
    txt_sbid: '设备ID',
    txt_jsxm: '技师姓名',
    txt_shoujhm: '手机号码',
    txt_dxyzmm: '短信验证码',
    txt_jishimz: '기술자',
    txt_ltlcgsnew: '타이어의 남은 수명은{0}km입니다',
    txt_ltlcgsnewin: 'Tire range is {0} miles',
    txt_pinnate_wear: '깃털형 마모',
    txt_msjxtx: '타이어가 한계에 달했으므로,즉시 교체하세요',
    txt_ltfz: '안과 밖을 반대로 장착.',
    txt_install_check: '설치 검사',
    txt_install_ok: '장착 정상',
    LF: '[좌측 전방 타이어]',
    RF: '[우측 전방 타이어]',
    LB: '[좌측 후방 타이어]',
    RB: '[우측 후방 타이어]',
    FF: '[앞축]',
    BB: '[뒤축]',
    txt_appearance_check:'타이어가 손상되었습니다. 확인하고 유지보수하세요',
    txt_uneven_center:'타이어 중간 마모 비정상, 타이어 공기압 검사를 받는 것이 좋습니다.',
    txt_uneven_out: '타이어 바깥쪽 마모 비정상, 휠 얼라인먼트 및 타이어 공기압 검사를 받는 것이 좋습니다.',
    txt_pinnate_check: '타이어 깃털형 마모, 섀시에 대한 추가 검사를 받는 것이 좋습니다.',
    txt_uneven_inside: '타이어 안쪽 마모 비정상, 휠 얼라인먼트 및 타이어 공기압 검사를 받는 것이 좋습니다.',
    'txt_do_further_check;': '추가 검사를 받으세요',
    txt_uneven_bothside: '타이어 양쪽 마모 비정상, 휠 얼라인먼트 및 타이어 공기업 검사를 받는 것이 좋습니다.',
    txt_msyzljgh: '타이어 마모 심각, 즉시 타이어를 교체하세요',
    txt_serious_trauma_check:"타이어 심각한 손상 발생, 타이어를 교체하는 것이 좋습니다",
    txt_appearance_lookup:"타이어 외관 상태를 확인하세요",
    txt_wear_lookup :"타이어 마모 상태를 확인하세요,",
    txt_dotscsj: '제조시간',
    txt_whqdscsj: '제조시간을 받지 못했습니다',
    txt_qiao: '축 브릿지',
    txt_left: '좌측',
    txt_right: '우측',
    txt_huawen: '트레드',
    txt_taihao: '타이어 번호',
    txt_taiya: '타이어 공기압',
    txt_chexlw: '휠 위치',
    txt_jiancerenyuan: '검사자',
    txt_beitai:'스페어 타이어',
    txt_tuoche:'트렉터',
    txt_guache:'트레일러',
    txt_chassis_check: '섀시 검사',
    txt_chassis_ok: '섀시 검사 양호',
    txt_chassis_oil: '쇼크 업소버 누유, 추가로 확인하고 필요한 경우 교체하는 것이 좋습니다.',
    txt_chassis_aging: '액슬 헤드 고무 노화, 교체하는 것이 좋습니다.',
    // new add  wu
    txt_lights:'조명',
    txt_high_beam:'상향등',
    txt_low_beam:'하향등',
    txt_daytime:'주간주행등',
    txt_fog_light:'안개등',
    txt_brake_light:'브레이크등',
    txt_turn_signals:'방향지시등',
    txt_backup_lights:'후진등',
    txt_hazards:'비상등',
    txt_glass:'유리',
    txt_windshield:'전면 유리',
    txt_back_glass:'후면 유리',
    txt_right_side_windows:'우측 유리',
    txt_left_side_windows:'좌측 유리',
    txt_wipers_front:'전면 와이퍼',
    txt_wipers_rear:'후면 와이퍼',
    txt_under_hood:'엔진룸',
    txt_horn:'경적',
    txt_oil_level:'오일 레벨',
    txt_air_filter:'에어 필터',
    txt_trans_fluid:'엔진 오일',
    txt_coolant_level:'부동액 레벨',
    txt_power_steering_fluid:'파워 스티어링 오일',
    txt_windshield_washer_fluid:'워셔액',
    txt_belts:'벨트',
    txt_hoses:'호스',
    txt_ac_system:'에어컨 시스템',
    txt_battery:'배터리',
    txt_under_vehicle:'섀시',
    txt_suspension:'서스펜션',
    txt_exhaust:'배기관',
    txt_brake_lines:'브레이크 라인',
    txt_oil_drain_plug:'오일 드레인 플',
    txt_differential:'차이',
    txt_brakes:'브레이크',
    txt_front_left:'좌측 전방 브레이크',
    txt_front_right:'우측 전방 브레이크',
    txt_rear_left:'좌측 후방 브레이크',
    txt_rear_right:'우측 후방 브레이크',
    txt_parking_brake:'주차 브레이크',
    txt_spare_pressure:'스페어 타이어 공기압',
    txt_interior:'내부',
    txt_cabin_fiter:'에어컨 필터',
    txt_heating:'히터',
    txt_interior_lights:'인테리어 조명',
    txt_front_defrost:'전면 제상',
    txt_rear_defrost:'후면 제상',
    txt_tire_pressure:'타이어 공기압',
    txt_left_front:'좌측 전방 타이어 공기압',
    txt_right_front:'우측 전방 타이어 공기압',
    txt_left_rear:'좌측 후방 타이어 공기압',
    txt_right_rear:'우측 후방 타이어 공기압',
    txt_null:'',
    //cormach
    txt_hood:'엔진 보닛',
    txt_wash_liquid:'워셔액',
    txt_level_control:'레벨 컨트롤',
    txt_haoxiaoxi:'OK',
    txt_vedi_Note:'설명서를 참조하세요 ',
    txt_replace1:'교체',
    txt_radiator_fluid:'라디에이터 액',
    txt_engine_oil:'엔진 오일',
    txt_brake_fluid:'브레이크 액',
    txt_quality_control:'품질 관리',
    txt_multimeter:'멀티미터 테스트',
    txt_subtotal:'소계',
    txt_shock_absorber:'쇼크 업소버',
    txt_check_loss:'손상 육안 검사',
    txt_brake_disc:'브레이크 디스크',
    txt_wear_condition:'마모 상태',
    txt_brake_pads:'브레이크 패드',
    txt_change_control:'변경 제어',
    txt_air_control:'에어컨 시스템',
    txt_last_reload:'마지막 새로고침',
    txt_lighting:'조명',
    txt_verification1:'와이퍼',
    txt_dynamometer:'동력계 조정',
    txt_batteria:'배터리',
    txt_verification:'검사 작업',
    txt_levellow:'정상',
    txt_levelmiddle:'작업 일정',
    txt_levelhigh:'교체',
    txt_tyrenumber:'스캔 깊이',
    txt_cormach_title:'마모&편마모',
    txt_wearlow:'균일한 트레드 마모',
    txt_wearmiddle:'경미한 마모',
    txt_wearhigh:'심각한 마모',
    txt_namtishi:'32도 타이어 표면 트레드 깊이',
    txt_zhiliangkongzhi:'품질 관리',
    txt_buchongzhengduan:'추가 진단',
    //米其林新加
    txt_trauma_eattyre:'타이어 마모 비정상',
    txt_uneven_eattyre:'타이어 마모 비정상, 동적 밸런스를 수행하고 휠 얼라인먼트 및 서스펜션 시스템 검사를 받는 것이 좋습니다.',
    txt_appearance_eattyre:'타이어 마모 비정상, 동적 밸런스를 수행하고 휠 얼라인먼트 및 서스펜션 시스템 검사를 받는 것이 좋습니다.',
    txt_chassis_eattyre:'타이어 마모 비정상, 휠 얼라인먼트 및 서스펜션 시스템 검사를 받는 것이 좋습니다.',
    txt_uneven_high_eattyre:'타이어의 심각한 비정상적 마모, 타이어를 교체하고 휠 얼라인먼트 및 서스펜션 시스템 검사를 받는 것이 좋습니다.',
    txt_appearance_high_eattyre:'타이어의 심각한 비정상적 마모, 동적 밸런스를 수행하고 휠 얼라인먼트 및 서스펜션 시스템 검사를 받는 것이 좋습니다.',
    txt_chassis_high_eattyre:'타이어의 심각한 비정상적 마모, 휠 얼라인먼트 및 서스펜션 시스템 검사를 받는 것이 좋습니다.',
    txt_chassis_uneven:'타이어의 비정상적 편마모, 휠 얼라인먼트 및 서스펜션 시스템 검사를 받는 것이 좋습니다.',
    txt_pianmoyichang:'타이어의 비정상적 편마모 ',
    txt_khxm:'고객 이름',
    txt_khyx:'고객 이메일',
    txt_tireplace: '타이어 보관지',
    txt_goods_name: '상품 명칭',
    txt_bolt: '볼트',
    txt_no: '아니오',
}


// WEBPACK FOOTER //
// ./src/i18n/ko.js